import  styled  from 'styled-components';

export const Img = styled.div`
  width: 28rem;
  transition: width 0.3s;

  &hover:{
    width: 32rem;
  }
`;
